<div class="main-container" (mouseleave)="showDialog = false">
	<div [ngClass]="{ highlight: chat.chatId === currentChatId }" class="chat-card" (click)="openChat()">
		<ng-icon class="icon-main-personality" [svg]="icons[!personalityId ? 'academic' : 'browser']" />
		<input
			#input
			[disabled]="!edit()"
			[(ngModel)]="title"
			type="text"
			maxlength="25"
			(focusout)="onNameChange()"
			(keydown.enter)="onNameChange()"
		/>

		<span class="show-hover date">{{
			(!personalityId
				? ('CHAT.PERSONALITY.ACADEMIC.TITLE' | translate)
				: ('CHAT.PERSONALITY.BROWSER.TITLE' | translate)) +
				' - ' +
				(chat.createdAt | date : 'longDate' : undefined :  translateService.currentLang)
		}}</span>
	</div>
	<i (click)="showDialog = !showDialog" class="icon show-hover unir-icon-dots-three"></i>
	<div class="dialog" *ngIf="showDialog">
		<a (click)="renameChat()"><i class="icon-submenu unir-icon-pencil-simple"></i>{{ 'CHAT.RENAME' | translate }}</a>
		<a class="danger" (click)="removeChat()"
			><i class="icon-submenu unir-icon-trash"></i>{{ 'CHAT.DELETE' | translate }}</a
		>
	</div>
</div>
